import { render, staticRenderFns } from "./DatasInclusaoAlteracao.vue?vue&type=template&id=2e9abcbe&scoped=true"
import script from "./DatasInclusaoAlteracao.vue?vue&type=script&lang=js"
export * from "./DatasInclusaoAlteracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9abcbe",
  null
  
)

export default component.exports